//print the table
export const printPrintWindow = (doc) => {
  const pdfBlob = doc.output('blob');
  const pdfURL = URL.createObjectURL(pdfBlob);

  const printWindow = window.open(pdfURL);

  if (printWindow) {
    printWindow.onload = () => printWindow.print();
  }
};
